import React from "react";
import Commons from '../../util/commons';
var { QRCodeSVG: QRCode } = require('qrcode.react');

class GlamourTemplateComponent extends React.Component {

    wrapText = (text, maxCharsPerLine = 80) => {
        if (!text) return '';
        return text.split('\n').map(line => {
            if (line.length <= maxCharsPerLine) return line;
            const words = line.split(' ');
            const wrappedLines = [];
            let current = '';
            for (const word of words) {
                if ((current + (current ? ' ' : '') + word).length > maxCharsPerLine && current) {
                    wrappedLines.push(current);
                    current = word;
                } else {
                    current = current ? current + ' ' + word : word;
                }
            }
            if (current) wrappedLines.push(current);
            return wrappedLines.join('\n');
        }).join('\n');
    }

    qrcodeValue = (invoiceUid) => {
        return window.location.host + "/mydata/" + invoiceUid;
    }

    getLogo = (logo) => {
        if (logo) {
            if (!logo.includes("blob:")) logo += "?" + Date.now();
            return <img alt="" src={logo} className="g-logo" />;
        }
    }

    createMoreTaxesTable(saleInstanceMoreTaxes, lang) {
        var rows = [];
        var types = [];
        saleInstanceMoreTaxes.sort((a, b) => a.myDataMoreTax.type.localeCompare(b.myDataMoreTax.type));
        saleInstanceMoreTaxes.forEach(e => {
            var type = e.myDataMoreTax.type;
            if (type === "DEDUCTION" && e.myDataMoreTax.label) {
                e.deduction = e.myDataMoreTax;
                e.deduction.name = e.myDataMoreTax.label;
            }
            if (e.deduction) type = "DEDUCTION";
            if (!types.includes(e.myDataMoreTax.type)) {
                types.push(e.myDataMoreTax.type);
            } else {
                type = "";
            }
            var TAX = e.myDataMoreTax ? "TAX_" + e.myDataMoreTax.uid : null;
            if (e.deduction) {
                rows.push(<tr key={Math.random()} className="g-tax-row"><td>{this.props.t(type, { lng: lang })}</td><td>{e.deduction.name}</td><td className="g-td-r">{e.amount}</td></tr>);
            } else {
                rows.push(<tr key={Math.random()} className="g-tax-row"><td>{this.props.t(type, { lng: lang })}</td><td>{this.props.t(TAX, { lng: lang })}</td><td className="g-td-r">{e.amount}</td></tr>);
            }
        });
        return rows;
    }

    createEntries = (entries) => {
        var rows = [];
        if (!entries) return rows;
        entries = entries.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
        const sale = this.props.sale;
        const lang = sale ? sale.TEMPLATE_LANG : undefined;
        const showMu = sale ? !Commons.isOnGroup(sale.MYDATA_INVOICE_TYPE, "noMeasurementUnit") : true;

        entries.forEach(entry => {
            const isEmpty = !entry.NAME_LIST;
            rows.push(
                <tr key={"entry_" + entry.id} className={isEmpty ? "g-row g-row-empty" : "g-row"}>
                    <td className="g-td-name"><small>{entry.NAME_LIST}</small></td>
                    <td className="g-td-r">{entry.QUANTITY_LIST}</td>
                    {showMu && <td className="g-td-r">{this.props.t(entry.MU_LIST, { lng: lang })}</td>}
                    <td className="g-td-r">{entry.UP_LIST}</td>
                    <td className="g-td-r">{entry.DISCOUNT}</td>
                    <td className="g-td-r">{entry.VAT_LIST}{entry.VAT_LIST ? "%" : ""}</td>
                    <td className="g-td-r">{entry.PRICE_NOVAT_LIST}</td>
                    <td className="g-td-r g-td-total">{entry.PRICE_LIST}</td>
                </tr>
            );
        });
        return rows;
    }

    createPage = (sale) => {
        const lang = sale.TEMPLATE_LANG;
        const t = (key, opts) => this.props.t(key, { lng: lang, ...opts });
        const showMu = !Commons.isOnGroup(sale.MYDATA_INVOICE_TYPE, "noMeasurementUnit");
        const showMove = sale.MOVE_PURPOSE || sale.VEHICLE_NUMBER || sale.DISPATCH_DATE || sale.LOADING_ADDRESS || sale.DELIVERY_ADDRESS;

        return (
            <div className="g-invoice-box" key={"box_" + Math.floor(Math.random() * 10000)}>

                {/* ── TOP GOLD RULE ── */}
                <div className="g-top-rule"></div>

                {/* ── HEADER ── */}
                <div className="g-header">
                    {sale.LOGO && (
                        <div className="g-logo-wrap">{this.getLogo(sale.LOGO)}</div>
                    )}
                    <div className="g-header-divider">
                        <div className="g-divider-line"></div>
                        <div className="g-issuer-name">{sale.ISSUER_NAME}</div>
                        <div className="g-divider-line"></div>
                    </div>
                    {sale.ISSUER_SUBJECTFIELD && <div className="g-issuer-sub">{sale.ISSUER_SUBJECTFIELD}</div>}
                    <div className="g-issuer-meta">
                        {sale.ISSUER_ADDRESS && <span>{sale.ISSUER_ADDRESS}</span>}
                        {sale.ISSUER_VAT && <span className="g-meta-sep">{t("TAXPAYER_ID")}: {sale.ISSUER_VAT}</span>}
                        {sale.ISSUER_DOY && <span className="g-meta-sep">{t("DOY")}: {sale.ISSUER_DOY}</span>}
                        {sale.ISSUER_GEMH && <span className="g-meta-sep">{t("GEMH")}: {sale.ISSUER_GEMH}</span>}
                        {sale.ISSUER_PHONE && <span className="g-meta-sep">{t("PHONE")}: {sale.ISSUER_PHONE}</span>}
                        {sale.ISSUER_EMAIL && <span className="g-meta-sep">{t("EMAIL")}: {sale.ISSUER_EMAIL}</span>}
                    </div>
                </div>

                {/* ── INVOICE INFO STRIP ── */}
                <div className="g-info-strip">
                    <div className="g-strip-type">{sale.INVOICE_TYPE}</div>
                    <div className="g-strip-number">{sale.INVOICE_NUMBER}</div>
                    <div className="g-strip-date">
                        <span className="g-strip-date-lbl">{t("IssueDate")}</span>
                        <span>{sale.INVOICE_DATE}</span>
                        {sale.INVOICE_TIME && <span className="g-strip-time">{sale.INVOICE_TIME}</span>}
                    </div>
                </div>

                {/* ── PARTIES ── */}
                <div className="g-parties">
                    <div className="g-party">
                        <div className="g-party-label">{t("customerSection")}</div>
                        <div className="g-party-name">{sale.CP_NAME}</div>
                        {sale.CP_SUBJECT_FIELD && <div className="g-party-row">{sale.CP_SUBJECT_FIELD}</div>}
                        {sale.CP_ADDRESS && <div className="g-party-row">{sale.CP_ADDRESS}</div>}
                        {(sale.CP_CITY || sale.COUNTRY) && (
                            <div className="g-party-row">{sale.CP_CITY}{sale.COUNTRY ? ", " + t(sale.COUNTRY) : ""}</div>
                        )}
                        {sale.CP_VAT && <div className="g-party-row"><span className="g-lbl">{t("TAXPAYER_ID")}:</span> {sale.CP_VAT}</div>}
                        {sale.CP_TAXOFFICE && <div className="g-party-row"><span className="g-lbl">{t("DOY")}:</span> {sale.CP_TAXOFFICE}</div>}
                        {sale.CP_PAYTYPE && <div className="g-party-row"><span className="g-lbl">{t("CP_PAYTYPE")}:</span> {t(sale.CP_PAYTYPE)}</div>}
                    </div>
                    {showMove && (
                        <div className="g-party g-party-transport">
                            <div className="g-party-label">{t("moveSection")}</div>
                            {sale.MOVE_PURPOSE && <div className="g-party-row"><span className="g-lbl">{t("MOVE_PURPOSE")}:</span> {sale.MOVE_PURPOSE}</div>}
                            {sale.VEHICLE_NUMBER && <div className="g-party-row"><span className="g-lbl">{t("VEHICLE_NUMBER")}:</span> {sale.VEHICLE_NUMBER}</div>}
                            {sale.DISPATCH_DATE && <div className="g-party-row"><span className="g-lbl">{t("DISPATCH_DATE")}:</span> {sale.DISPATCH_DATE}</div>}
                            {sale.LOADING_ADDRESS && <div className="g-party-row"><span className="g-lbl">{t("LOADING_ADDRESS")}:</span> {sale.LOADING_ADDRESS}</div>}
                            {sale.DELIVERY_ADDRESS && <div className="g-party-row"><span className="g-lbl">{t("DELIVERY_ADDRESS")}:</span> {sale.DELIVERY_ADDRESS}</div>}
                        </div>
                    )}
                </div>

                {/* ── PRODUCT TABLE ── */}
                <div className="g-table-wrap">
                    <table className="g-product-table">
                        <thead>
                            <tr>
                                <th className="g-th-name">{t("PROD_SERV")}</th>
                                <th className="g-th-r">{t("QUANTITY")}</th>
                                {showMu && <th className="g-th-r">{t("MUN")}</th>}
                                <th className="g-th-r">{t("UNIT_PRICE")}</th>
                                <th className="g-th-r">{t("DISCOUNT")}</th>
                                <th className="g-th-r">{t("VAT")} %</th>
                                <th className="g-th-r">{t("PRICE_WITHOUT_VAT")}</th>
                                <th className="g-th-r">{t("PRICE_WITH_VAT")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.createEntries(sale.entries)}
                        </tbody>
                    </table>
                </div>

                {/* ── BOTTOM (pinned) ── */}
                <div className="g-bottom-section">

                    <div className="g-footer-section">
                        <div className="g-footer-left">
                            <div className="g-notes-block">
                                <div className="g-block-lbl">{t("NOTES")}</div>
                                <div className="g-notes-text" style={{ whiteSpace: 'pre-wrap' }}>{this.wrapText(sale.NOTES)}</div>
                            </div>
                            {sale.saleInstanceMoreTaxes && sale.saleInstanceMoreTaxes.length > 0 && (
                                <table className="g-moretax-table">
                                    <tbody>
                                        {this.createMoreTaxesTable(sale.saleInstanceMoreTaxes, lang)}
                                    </tbody>
                                </table>
                            )}
                            <div className="g-qr-wrap">
                                <QRCode
                                    size={72}
                                    bgColor="#ffffff"
                                    fgColor={this.props.mainStyle ? (this.props.mainStyle.match(/--appcolor:\s*([^;]+)/)?.[1]?.trim() || "#c9a96e") : "#c9a96e"}
                                    level="L"
                                    marginSize={0}
                                    value={sale.QRURL ? sale.QRURL : this.qrcodeValue(sale.INVOICEUID)}
                                />
                            </div>
                        </div>

                        <div className="g-footer-right">
                            {!Commons.isOnGroup(sale.MYDATA_INVOICE_TYPE, "noCountItems") && (
                                <div className="g-count-items">
                                    {t("TOTALITEMS")}: <strong>{sale.TOTALCOUNTITEMS}</strong>
                                </div>
                            )}
                            <table className="g-totals-table">
                                <tbody>
                                    <tr>
                                        <td>{t("TOTALVALUE")}</td>
                                        <td className="g-td-r">{sale.TOTALNODISCOUNT}</td>
                                    </tr>
                                    <tr>
                                        <td>{t("DISCOUNT")}</td>
                                        <td className="g-td-r">{sale.TOTALDISCOUNT}</td>
                                    </tr>
                                    <tr>
                                        <td>{t("VATVALUE")}</td>
                                        <td className="g-td-r">{sale.TOTALVAT}</td>
                                    </tr>
                                    {sale.TOTALTAXES && (
                                        <tr>
                                            <td>{t("MORETAXES")}</td>
                                            <td className="g-td-r">{sale.TOTALTAXES}</td>
                                        </tr>
                                    )}
                                    <tr className="g-total-final">
                                        <td>{t("PAYAMOUNT")}</td>
                                        <td className="g-td-r">{sale.TOTALPAYMENT}</td>
                                    </tr>
                                    {sale.CURRENCY && sale.CURRENCY !== "EUR" && (
                                        <tr>
                                            <td>{t("TOTALPAYMENT_ON_CURRENCY", { currency: sale.CURRENCY })}</td>
                                            <td className="g-td-r">{sale.TOTALPAYMENT_ON_CURRENCY} <span className="g-currency">{sale.CURRENCY}</span></td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            {sale.IBAN && <div className="g-iban">{sale.IBAN}</div>}
                            <div className="g-signatures">
                                <div className="g-sign-box">
                                    <div className="g-sign-lbl">{t("ISSUANCE")}</div>
                                    <div className="g-sign-line"></div>
                                    <div className="g-sign-sub">{t("Signature")}</div>
                                </div>
                                <div className="g-sign-box">
                                    <div className="g-sign-lbl">{t("RECEIPT")}</div>
                                    <div className="g-sign-line"></div>
                                    <div className="g-sign-sub">{t("Signature")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {(sale.VAT_EXCEPTION_CATEGORIES?.[0] || sale.MOREINFO || sale.CORRELATIVE_INVOICE) && (
                        <div className="g-extra-info">
                            {sale.VAT_EXCEPTION_CATEGORIES?.[0] && (
                                <div><small><strong>{t("vatCategoryExceptionShort")}:</strong> {t(sale.VAT_EXCEPTION_CATEGORIES[0])}</small></div>
                            )}
                            {sale.MOREINFO && <div>{t(sale.MOREINFO)}</div>}
                            {sale.CORRELATIVE_INVOICE && <div><small>{t("correlativeSales")} {t(sale.CORRELATIVE_INVOICE)}</small></div>}
                        </div>
                    )}

                    <div className="g-mydata-footer">
                        <div className="g-mydata-row">
                            {sale.INVOICEUID && (
                                <span><span className="g-mydata-lbl">uid:</span> <span className="g-mydata-val">{sale.INVOICEUID}</span></span>
                            )}
                            {sale.INVOICEMARK
                                ? <span><span className="g-mydata-lbl">mark:</span> <span className="g-mydata-val">{sale.INVOICEMARK}</span></span>
                                : <span className="g-not-published">{t("notPublished")}</span>
                            }
                            {sale.CANCELATIONMARK && (
                                <span><span className="g-mydata-lbl">cancelationMark:</span> <span className="g-mydata-val">{sale.CANCELATIONMARK}</span></span>
                            )}
                        </div>
                        <div className="g-createdby">{t("CREATEDBY")}</div>
                    </div>

                </div>{/* end g-bottom-section */}

            </div>
        );
    }

    createPages = (sale) => {
        var pages = [];
        var chunk = 13;
        if (sale && sale.INVOICE_ENTRIES != undefined) {
            for (var i = 0, j = sale.INVOICE_ENTRIES.length; i < j; i += chunk) {
                var groupEntries = sale.INVOICE_ENTRIES.slice(i, i + chunk);
                var groupSale = Object.assign({}, sale, { entries: groupEntries });
                pages.push(this.createPage(groupSale));
            }
        }
        return pages;
    }

    getMainStyle = () => {
        if (this.props.mainStyle) return <style>{this.props.mainStyle}</style>;
    }

    getExtraCss = () => {
        if (this.props.extracss) return <style>{this.props.extracss}</style>;
    }

    render() {
        return (
            <div id="template_page" className="page template_page">
                <link type="text/css" rel="stylesheet" href="../template-glamour.css" />
                <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" type="text/css" />
                {this.getMainStyle()}
                {this.getExtraCss()}
                {this.createPages(this.props.sale)}
            </div>
        );
    }
}

export default GlamourTemplateComponent;
